
import React from 'react'
import {
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    DateField,
    TextField,
    ArrayField,
    SingleFieldList,
    EditButton,
    TextInput,
    DateInput,
    Responsive,
    SimpleList,
    SimpleShowLayout,
    ShowButton,
    Show,
    UrlField,
    SelectInput,
    Filter,
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    Pagination,
    Button,
    ChipField,
    required,
    sanitizeListRestProps,
    SaveButton,
    DeleteButton,
    Toolbar,
    ArrayInput,
    SimpleFormIterator,
    NumberInput,
    AutocompleteInput,
    AutocompleteArrayInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectArrayInput,
    ImageField,
    ReferenceField,
} from 'react-admin'
import { cloneElement, useMemo } from 'react'
import PropTypes from 'prop-types'
import BookIcon from '@material-ui/icons/TrendingUp'
import ShortUrlField from '../Customs/ShortUrlField'
import MultipleField from '../Customs/MultipleField'
import MultipleInput from '../Customs/MultipleInput'
import DeleteAllButton from '../Customs/DeleteAllButton'
import ImportButton from '../Customs/ImportButton'
import DuplicateButton from '../Customs/DuplicateButton'
import ApiSelectInput from '../Customs/ApiSelectInput'
import MoveFormIterator from '../Customs/MoveFormIterator'
import GalleryInput from '../Customs/GalleryInput'


const API_URL = process.env.REACT_APP_API_HOSTNAME

export const SeopathIcon = BookIcon


const Seopath_Filter = (props) => (
    <Filter {...props}>
        <TextInput source="match_path" options={{ maxLength: 1024 }} />
        <ReferenceInput source="website" reference="Website" perPage={10000} >
            <AutocompleteInput optionText="ndd" />
        </ReferenceInput>
    </Filter>
)

const ListActions_Store = {}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props
    let {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext()
    ListActions_Store.filterValues = filterValues
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
        </TopToolbar>
    )
}

export const SeopathList = (props) => (
    <List {...props} filters={<Seopath_Filter />} actions={<ListActions />} perPage={10}>
        <Responsive
            small={
                <SimpleList linkType="show"
                    primaryText={record => record ? record.path : ''}
                />
            }
            medium={
                <Datagrid>
                    <TextField source="id" sortable={true} />
                    <TextField source="path" sortable={true} />
                    <ReferenceField source="website" reference="Website" >
                        <TextField source="ndd" />
                    </ReferenceField>
                    <DateField source="updatedAt" showTime={true} sortable={true} />
                    <EditButton />
                    <ShowButton />
                    <DuplicateButton />
                </Datagrid>
            }
        />
    </List>
)

export const SeopathShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="path" />
            <TextField source="title" />
            <TextField source="description" />
            <ArrayField source="images">
                <Datagrid>
                    <TextField source="image" />
                    <ImageField source="image_url" />
                    <TextField source="width" />
                    <TextField source="height" />
                    <TextField source="alt" />
                </Datagrid>
            </ArrayField>
            <ReferenceField source="website" reference="Website" >
                <TextField source="ndd" />
            </ReferenceField>
            <DateField source="createdAt" showTime={true} />
            <DateField source="updatedAt" showTime={true} />
        </SimpleShowLayout>
    </Show>
)

const CustomToolBar = props => <Toolbar {...props} ><SaveButton /></Toolbar>

export const SeopathEdit = (props) => (
    <Edit {...props} undoable={false} toolbar={<CustomToolBar />} >
        <SimpleForm redirect="show">
            <TextInput source="path" validate={required()} style={{ width: "800px" }} />
            <TextInput source="title" style={{ width: "800px" }} />
            <TextInput source="description" style={{ width: "800px" }} />
            <ArrayInput source="images">
                <MoveFormIterator>
                    <GalleryInput source="image" optionText="s3_key" />

                    {/* <ReferenceInput source="image" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <NumberInput source="width" validate={required()} />
                    <NumberInput source="height" validate={required()} />
                    <TextInput source="alt" validate={required()} />
                </MoveFormIterator>
            </ArrayInput>
            <ReferenceInput source="website" reference="Website" perPage={10000} >
                <AutocompleteInput optionText="ndd" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
)

export const SeopathCreate = (props) => (
    <Create {...props} undoable={false} toolbar={<CustomToolBar />} >
        <SimpleForm redirect="show">
            <TextInput source="path" validate={required()} style={{ width: "800px" }} />
            <TextInput source="title" style={{ width: "800px" }} />
            <TextInput source="description" style={{ width: "800px" }} />
            <ArrayInput source="images">
                <MoveFormIterator>
                    <GalleryInput source="image" optionText="s3_key" />

                    {/* <ReferenceInput source="image" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <NumberInput source="width" validate={required()} />
                    <NumberInput source="height" validate={required()} />
                    <TextInput source="alt" validate={required()} />
                </MoveFormIterator>
            </ArrayInput>
            <ReferenceInput source="website" reference="Website" perPage={10000} >
                <AutocompleteInput optionText="ndd" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
)
